module.exports = __webpack_public_path__ + "media/images/channels/ophthalmology-acfcc9ce430ec8808371a505d62ea504.jpg";